export default __webpack_public_path__ + "static/media/logo-max-light.87aa864f.png";